import parse from "html-react-parser";
import { memo } from "react";

import { PATH_FAVORITES, PATH_SEARCH_RESULT } from "@routes";
import { ITourElement } from "@interfaces";
import { StyledTourElementMain, StyledTourElement } from "@components";
import { sliceString } from "@utilities";
import useImageFallback from "src/Utilities/imageFallbackHelper";
import { getTour, useAppDispatch } from "@redux";


interface IProps {
    data: ITourElement;
}

export const TourElementModule = memo((props: IProps) => {
    const dispatch = useAppDispatch();
    const pathname = window.location.pathname;
    const {
        productImagePath,
        name,
        location,
        durationDays,
        durationNight,
        rrp,
        description,
        supplier,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    } = props.data;
    // const isLiked = favoritesTours.some((tour) => tour.productId === props.data.productId);
    const Fragment = StyledTourElementMain;
    const isFavoritePage = window.location.pathname === PATH_FAVORITES;

    let duringTime = "";
    if (Number(durationDays) > 0) {
        duringTime += `${durationDays} ${Number(durationDays) === 1 ? "day" : "days"}`;
    }
    if (Number(durationDays) > 0 && Number(durationNight) > 0) {
        duringTime += " , ";
    }
    if (Number(durationNight) > 0) {
        duringTime += `${durationNight} ${Number(durationNight) === 1 ? "night" : "nights"}`;
    }

    const imageSrc = useImageFallback({
        productImagePath,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    });


    return (
        <StyledTourElement>
            <div
                className={`heart ${pathname === PATH_SEARCH_RESULT ? "searchResultPage" : ""}`}
                style={pathname.includes("favorites") ? { right: "15px" } : {}}
            ></div>
            <Fragment
                to={`/detail-tour/${props.data.productId}`}
                style={pathname.includes("favorites") ? { width: "unset", margin: 0 } : {}}
                onClick={async () => {
                    await dispatch(getTour(props.data.productId));
                }}
            >
                <div
                    className="tour_image"
                    style={{
                        backgroundImage: `url(${imageSrc})`,
                    }}
                ></div>
                <div className="main">
                    <div className="info">
                        <p className="destination__title">{name}</p>
                        <p className="destination__place">
                            <span className="placeName">{location}</span>
                        </p>
                        {!isFavoritePage && !!description && !(typeof description === "object") && (
                            <div className="description">
                                <span>{parse(description)}</span>
                            </div>
                        )}
                        {!!supplier && !(typeof description === "object") && (
                            <div className="supplier">
                                Supplier <span>{sliceString(supplier, 4)}</span>
                            </div>
                        )}
                    </div>
                    <div className="durationNPrice">
                        <div className="destination__price">
                            <span className="form">From</span>
                            <span className="price">${Number(rrp).toFixed(2)}</span>
                        </div>

                        <div className="destination__duration">
                            <span className="time">{duringTime}</span>
                        </div>
                    </div>
                </div>
            </Fragment>
        </StyledTourElement>
    );
});